import React from 'react';
import {Card, message} from 'antd';
import UserRegisterForm, {IUserRegisterForm} from '../../components/user/RegisterForm';
import UseUser from '../../hooks/apis/useUser';
import UserLoginForm, {IUserLoginForm} from '../../components/user/LoginForm';
import useAuth from '../../utils/AuthContext';
import QuickRouter from '../../utils/QuickRouter';
import useQuickRouter from '../../utils/QuickRouter';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function UserLoginPage() {
  const loginState = UseUser.login();
  const auth = useAuth();
  const quickRouter = useQuickRouter();

  function login(form: IUserLoginForm) {
    loginState
      .request(form)
      .then(res => {
        message.success('登录成功');
        auth.setCurrentUser(res.user);
        auth.setToken(res.token);
        localStorage.setItem('Application-Token', res.token || '');
        if (res.user.legalName) return quickRouter.index();
        else return quickRouter.userProfile();
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <div>
      <UserLoginForm isLoading={loginState.loading} onFinish={login} />
    </div>
  );
}
